module.exports = __webpack_public_path__ + "img/spinner-icon.e4bec1eb.svg";